module.exports = __webpack_public_path__ + "static/media/strongher6_preview.fe40eac5.jpg";